export default __webpack_public_path__ + "static/media/NIAS0350.34I-32908_-17925_0.84a5ef6e.jpg";